import React from 'react';
import {StyleSheet} from 'react-native';

import Text, {TextProps} from '../Text';

export const Title = (props: TextProps) => (
  <Text variant="heading1" style={styles.main} {...props}>
    {props.children}
  </Text>
);

const styles = StyleSheet.create({
  main: {
    marginVertical: 8,
  },
});
